const LABELS = {
  awaiting_upload: "Awaiting Upload",
  in_progress: "In Progress",
  submitted: "Submitted",
  in_review: "In Review",
  completed: "Completed",
};
const COLORS = {
  awaiting_upload: "border-white/30 text-white/70",
  in_progress: "border-yellow-500/60 text-yellow-400",
  submitted: "border-blue-400/60 text-blue-300",
  in_review: "border-[#2A5BFF] text-[#2A5BFF]",
  completed: "border-emerald-500/60 text-emerald-400",
};

export default function StatusPill({ status, testid }) {
  const key = status || "awaiting_upload";
  return (
    <span
      className={`inline-flex items-center px-2 py-1 border text-[10px] tracking-[0.22em] uppercase ${COLORS[key] || COLORS.awaiting_upload}`}
      data-testid={testid || "status-pill"}
    >
      {LABELS[key] || key}
    </span>
  );
}

export const STATUS_LABELS = LABELS;
